<header>
  <section navigation>
    <nav>
      <ac-icon class="lg:!hidden pointer" name="menu" size="big" (click)="menuTrigger.emit()" />
      <ac-home-logo />
      @if (!_isRehabilitationContextSig()) {
        <ac-nav-links />
      }
    </nav>

    <section class="client-info">
      @if (_shouldRenderLangSelection) {
        <ac-lang-selection />
      }
      @if (!_isRehabilitationContextSig()) {
        <ac-help-trigger />
      }
      <ac-profile-trigger />
    </section>
  </section>
  @if (_authUserSig() && !_isRehabilitationContextSig()) {
    <section>
      <ac-notifications-trigger />
    </section>
  }
</header>
